import styled from 'styled-components';

export const StyledToggleAll = styled.div`
    cursor: pointer;
    &:focus-visible {
        outline: 2px solid #005ba8; /* Add a visible border for focus */
        outline-offset: 4px; /* Adjust spacing between the border and the element */
    }
`;
